import React from 'react';
import { PromotionalGraphicProps } from './PromotionalGraphic';
import GraphicDetailCard from './GraphicDetailCard';
interface GraphicsLightboxProps {
  graphic: PromotionalGraphicProps;
  onClose: () => void;
  // Optional props for gallery navigation if needed in future
  onPrev?: () => void;
  onNext?: () => void;
  itemIndex?: number;
  totalItems?: number;
}
const GraphicsLightbox: React.FC<GraphicsLightboxProps> = ({
  graphic,
  onClose,
  onPrev,
  onNext,
  itemIndex,
  totalItems
}) => {
  return <GraphicDetailCard imageUrl={graphic.imageUrl} title={graphic.title || graphic.bookTitle} // Fallback to book title if graphic has no title
  // Author info
  authorName={graphic.authorName} authorId={graphic.authorId}
  // Book info
  bookTitle={graphic.bookTitle} bookId={graphic.bookId}
  // Metadata
  type={graphic.type} description={graphic.description} tags={graphic.tags}
  // Navigation
  onClose={onClose} onPrev={onPrev} onNext={onNext} itemIndex={itemIndex} totalItems={totalItems}
  // Actions
  onDownload={() => console.log('Download', graphic.id)} onShare={() => console.log('Share', graphic.id)} data-id="element-1720" data-mp="36t7btv2rafjq" />;
};
export default GraphicsLightbox;